import { Dialog } from "@headlessui/react";
import { useNavigate } from "react-router";
import { useTranslation, Trans } from "react-i18next";

import DialogBackdrop from "../../ModalDialogs/DialogBackdrop";
import Countdown from "react-countdown";
import config from "config/config";

const AgentSessionRefresherModel = ({
  modalState,
  setModalState,
  extendSession,
}) => {
  let navigate = useNavigate();
  const { t } = useTranslation();

  const sessionTimeoutRenderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setModalState(false);
      navigate("/?type=sessionTimeOut");
      return;
    } else {
      return (
        <>
          <button
            className="ui-btn-secondary ui-btn-min-w mt-4"
            onClick={() => LogOut()}
          >
            {t("AgentSessionRefresherModel-logoutButton-label")} (0{minutes}:
            {seconds < 10 ? `0${seconds}` : seconds})
          </button>
        </>
      );
    }
  };
  const LogOut = () => {
    setModalState(false);
    navigate("/");
  };

  return (
    <>
      <Dialog open={modalState} onClose={() => null} className="ui-dialogs">
        <DialogBackdrop />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              {t("AgentSessionRefresherModel-sessionExpireTitle")}
            </Dialog.Title>
            <hr />
            <Dialog.Description>
              {t("AgentSessionRefresherModel-sessionExpireDescription")}
            </Dialog.Description>
            <div className="block text-right">
              <button
                className="ui-btn-primary ui-btn-min-w mt-4"
                onClick={() => extendSession()}
              >
                <Trans
                  i18nKey="AgentSessionRefresherModel-extendSessionButton-label"
                  components={{
                    span1: <span className="sr-only" />,
                  }}
                />
              </button>
              <Countdown
                date={Date.now() + parseInt(config.LOGOUT_TIMEOUT)}
                renderer={sessionTimeoutRenderer}
              />
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default AgentSessionRefresherModel;
